import {observer} from 'mobx-react';
import React from 'react';
import {AddContentControls} from '../x7/content-parts/AddContentControls';
import {AddContentStore} from '../x7/content-parts/AddContentStore';
import {FlashcardsCreate} from './flashcard/crud/FlashcardsCreate';
import {GapFillingCreateComponent} from './gap-filling/crud/GapFillingCreateComponent';
import {GrexCreate} from './grouping-exercise/crud/GrexCreate';
import {X9MatchingQuestionCreate} from './matching-question/crud/X9MatchingQuestionCreate';
import {X9McqCreate} from './mcq/crud/X9McqCreate';
import {OpenEndedQuestionInlineCreate} from './open-ended-question-inline/crud/OpenEndedQuestionInlineCreate';
import {SelectQuestionCreateComponent} from './select-question/crud/SelectQuestionCreateComponent';
import {SlideShowCreate} from './slideshow/crud/SlideShowCreate';
import {X9StaticHtmlCreate} from './static-html/X9StaticHtmlCreate';
import {X9StaticImageCreate} from './static-image/X9StaticImageCreate';
import {X9SyncedAudioCreate} from './synced-audio/crud/X9SyncedAudioCreate';
import {X9SyncedVideoCreate} from './synced-video/crud/X9SyncedVideoCreate';

@observer
export class X9ContentCreate extends React.Component<{ store: AddContentStore }> {
  render() {
    const store = this.props.store;

    switch (store.contentType) {
      case 'static-html':
        return (<>
          <X9StaticHtmlCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'static-image':
        return (<>
          <X9StaticImageCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'matching-question':
        return (<>
          <X9MatchingQuestionCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'select-question':
        return (<>
          <SelectQuestionCreateComponent store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'gap-filling':
        return (<>
          <GapFillingCreateComponent store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'multiple-choice-question':
        return (<>
          <X9McqCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'grouping-exercise':
        return (<>
          <GrexCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'flashcards':
        return (<>
          <FlashcardsCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'slideshow':
        return (<>
          <SlideShowCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'open-ended-question':
        return (<>
          <AddContentControls store={store}/>
        </>);
      case 'open-ended-question-inline':
        return (<>
          <OpenEndedQuestionInlineCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'synced-audio':
        return (<>
          <X9SyncedAudioCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
      case 'synced-video':
        return (<>
          <X9SyncedVideoCreate store={store}/>
          <AddContentControls store={store}/>
        </>);
    }

    return (
      <div className="row justify-content-center">
        <div className="col-auto">
          <div className="alert alert-danger">
            I don't know how to handle content type {store.contentType}
          </div>
        </div>
      </div>);
  }

  componentDidMount() {
    const store = this.props.store;
    switch (store.contentType) {
      case 'open-ended-question': {
        store.setValid(true);
        store.setContents(JSON.stringify({}));
        store.complete();
      }
    }
  }
}
